<template>
  <div class="role-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            class="btn-color ml-4"
            @click.prevent="exportCsv()"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.roles") }}</label>
          <v-select
            v-model="role"
            :options="filterRoles"
            :reduce="(filterRoles) => filterRoles.value"
            label="text"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search && !this.role"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.role"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.user_roles')">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.roles") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddRole' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('role', 'add')"
              >{{ $t("labels.add_role") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="roles" class="role-listing permission">
        <template slot="thead">
          <vs-th class="col-md-4">{{ $t("labels.role_name") }}</vs-th>
          <vs-th class="col-md-5">{{ $t("labels.role_description") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">{{ tr.name }}</vs-td>
            <vs-td :data="tr.description">{{ tr.description }}</vs-td>
            <vs-td class="pl-0" width="150">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.view')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-eye"
                  class="mr-2"
                  color="dark"
                  @click="
                    $router.push({ name: 'ViewRole', params: { id: tr.id } })
                  "
                  v-if="checkPermission('role', 'view')"
                ></vs-button>
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({ name: 'EditRole', params: { id: tr.id } })
                  "
                  v-if="checkPermission('role', 'modify')"
                ></vs-button>
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-if="
                    !tr.is_system_defined && checkPermission('role', 'delete')
                  "
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";

export default {
  components: {
    KeyIcon,
  },
  data() {
    return {
      roles: [],
      showfilter: false,
      totalPage: 1,
      currentx: 1,
      search: null,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      role: null,
      filterRoles: [
        { text: this.$t("labels.only_admin"), value: true },
        { text: this.$t("labels.all"), value: false },
      ],
    };
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getRoles();
    },
    currentx(val) {
      this.getRoles();
    },
  },
  computed: {},
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getRoles();
  },
  methods: {
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteRole,
      });
    },
    async deleteRole() {
      if (this.index < 0) return;
      let url = "role/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.roles[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getRoles();
      }
    },
    async getRoles(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        only_admin_roles: this.role,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/role", input);
      if (exp) {
        this.exportFile(response, "Roles");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let roles = data.roles;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.roles = roles;
        }
      }
    },
    exportCsv() {
      this.getRoles(true);
    },
    filter() {
      this.getRoles();
    },
    clearFilter() {
      this.search = null;
      this.role = null;
      this.getRoles();
    },
  },
};
</script>
